import { useTranslation } from 'react-i18next';

export default function LocationSection() {
  const { t } = useTranslation();

  const distances = [
    { icon: 'ri-water-flash-line', label: t('location.distanceBeach') },
    { icon: 'ri-ship-line', label: t('location.distanceHarbor') },
    { icon: 'ri-building-line', label: t('location.distanceTown') },
    { icon: 'ri-landscape-line', label: t('location.distanceWadden') },
  ];

  return (
    <section id="location" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
            <div className="w-full lg:w-1/2 order-2 lg:order-1">
              <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">
                {t('location.subtitle')}
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3">
                {t('location.title')}
              </h2>
              <p className="mt-6 text-foreground-700 leading-relaxed">
                {t('location.description')}
              </p>

              <div className="mt-8 grid grid-cols-2 gap-4">
                {distances.map((d) => (
                  <div
                    key={d.label}
                    className="flex items-center gap-3 p-4 bg-background-50 rounded-lg"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                      <i className={`${d.icon} text-lg`} />
                    </div>
                    <span className="text-sm font-medium text-foreground-800">
                      {d.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full lg:w-1/2 order-1 lg:order-2">
              <div className="rounded-lg overflow-hidden border-2 border-background-200">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19308.633245404788!2d7.459999999999999!3d53.671446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b62c0d1f5e5c5d%3A0x8c5d2e8e1a2b3c4d!2sDornumersiel!5e0!3m2!1sde!2sde!4v1600000000000!5m2!1sde!2sde"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps Dornumersiel"
                  className="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}